module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./SubmitView.js"));
	}, "AfterSaleSubmitView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleSubmitView!./src/pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/Submit/SubmitView.js
// module id = 1974
// module chunks = 367